import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {GRAY_DARKER, GRAY_LIGHT, GRAY_LIGHTER} from 'ui-library/Colors';

export function SimpleTable(props: {
  columns: Array<string | JSX.Element>;
  values: Array<Array<string | JSX.Element>>;
}): JSX.Element {
  return (
    <div className={css(styles.table)}>
      <div className={classNames(css(styles.header), 'legacy-font-proxima-13', 'font-proxima-semibold')}>
        {props.columns.map((column: string, idx: number) => (
          <div key={`simpletable-col-${column}-${idx}`} className={css(styles.cell)}>
            {column}
          </div>
        ))}
      </div>
      {props.values.map((row: Array<string>, idx: number) => (
        <div
          key={`simpletable-row-${row}-${idx}`}
          className={classNames(css(styles.row), 'legacy-font-proxima-13')}
        >
          {row.map((cell: string, idx: number) => (
            <div key={`simpletable-val-${cell}-${idx}`} className={css(styles.cell)}>
              {cell}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  table: {
    border: '1px solid',
    borderColor: GRAY_LIGHT,
    borderRadius: '4px',
    width: '100%',
  },
  header: {
    background: GRAY_LIGHTER,
    color: GRAY_DARKER,
    display: 'flex',
    flexWrap: 'wrap',
    padding: '12px 14px',
    width: '100%',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
  },
  cell: {
    display: 'inline-block',
    flex: '2',
  },
  row: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    borderTop: '1px solid',
    borderColor: GRAY_LIGHT,
    padding: '12px 14px',
    ':hover': {
      background: GRAY_LIGHTER,
    },
  },
});
